export const builtInCommands = [
    "formant.get_file",
    "formant.run_script",
    "formant.publish_ros_topic",
    "formant.demand_data",
] as const;

export function lookupCommandInfo(command: string) {
    switch (command) {
        case "formant.get_file":
            return {
                commandDescription: "Get a file from the device.",
                parameterDescription: "Absolute file path on device",
            };
        case "formant.run_script":
            return {
                commandDescription: "Run a script on the device.",
                parameterDescription:
                    "Absolute file path of the script on the device",
            };
        case "formant.publish_ros_topic":
            return {
                commandDescription: "Publish a string to a ROS topic.",
                parameterDescription: "String to be published to the ROS topic",
            };
        case "formant.demand_data":
            return {
                commandDescription: "Upload data on demand from a device.",
                parameterDescription: "Command parameters",
            };
        default:
            return {
                commandDescription: "",
                parameterDescription: "Command parameters",
            };
    }
}
